"use client"

import { useState } from "react"
import AbacusDisplay from "./AbacusDisplay"

const CountAndColor = ({ onScore }) => {
  const [currentTask, setCurrentTask] = useState(0)
  const [coloredItems, setColoredItems] = useState([])

  const tasks = [
    { abacusValue: 1, totalItems: 4, instruction: "Раскрась 1 гранат" },
    { abacusValue: 2, totalItems: 4, instruction: "Раскрась 2 граната" },
    { abacusValue: 3, totalItems: 4, instruction: "Раскрась 3 граната" },
    { abacusValue: 4, totalItems: 4, instruction: "Раскрась 4 граната" },
  ]

  const current = tasks[currentTask]

  const colorItem = (index) => {
    if (coloredItems.includes(index)) {
      setColoredItems(coloredItems.filter((i) => i !== index))
    } else if (coloredItems.length < current.abacusValue) {
      setColoredItems([...coloredItems, index])
      if (coloredItems.length + 1 === current.abacusValue) {
        onScore(25)
        setTimeout(() => {
          setCurrentTask((prev) => (prev + 1) % tasks.length)
          setColoredItems([])
        }, 2000)
      }
    }
  }

  return (
    <div className="lesson-card card-red">
      <h2 className="lesson-title" style={{ color: "#991b1b" }}>
        Считаем и раскрашиваем 🎨
      </h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "24px",
          marginBottom: "24px",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h3 style={{ fontSize: "1.125rem", fontWeight: "bold", marginBottom: "16px" }}>Абакус показывает</h3>
          <AbacusDisplay value={current.abacusValue} />
        </div>

        <div style={{ textAlign: "center" }}>
          <h3 style={{ fontSize: "1.125rem", fontWeight: "bold", marginBottom: "16px" }}>Задание</h3>
          <div
            style={{
              fontSize: "1.25rem",
              backgroundColor: "white",
              padding: "16px",
              borderRadius: "8px",
              border: "2px solid #e5e7eb",
            }}
          >
            {current.instruction}
          </div>
          <div style={{ fontSize: "1.125rem", marginTop: "8px", color: "#4b5563" }}>
            Раскрашено: {coloredItems.length}/{current.abacusValue}
          </div>
        </div>
      </div>

      <div style={{ textAlign: "center", marginBottom: "24px" }}>
        <h3 style={{ fontSize: "1.125rem", fontWeight: "bold", marginBottom: "16px" }}>
          Нажми на гранаты, чтобы раскрасить:
        </h3>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "16px",
            maxWidth: "400px",
            margin: "0 auto",
          }}
        >
          {Array.from({ length: current.totalItems }, (_, index) => (
            <button
              key={index}
              onClick={() => colorItem(index)}
              style={{
                width: "64px",
                height: "64px",
                fontSize: "1.875rem",
                borderRadius: "50%",
                border: "4px solid",
                backgroundColor: coloredItems.includes(index) ? "#ef4444" : "white",
                borderColor: coloredItems.includes(index) ? "#dc2626" : "#d1d5db",
                color: coloredItems.includes(index) ? "white" : "#374151",
                cursor: "pointer",
              }}
            >
              {coloredItems.includes(index) ? "🟥" : "⚪"}
            </button>
          ))}
        </div>
      </div>

      {coloredItems.length === current.abacusValue && (
        <div
          style={{
            textAlign: "center",
            fontSize: "1.25rem",
            color: "#16a34a",
            fontWeight: "bold",
          }}
        >
          🎉 Отлично! Правильно раскрасил {current.abacusValue} {current.abacusValue === 1 ? "гранат" : "граната"}! 🎉
        </div>
      )}
    </div>
  )
}

export default CountAndColor
